import Header from "./components/header/header";
import SectionHero from "./components/section_hero/section_hero";
import ProductSection from "./components/products_section/product_section";
import CtaAboutUs from "./components/section_cta_aboutUs/cta_aboutUs";
import Footer from "./components/footer/footer";
import AboutTheRobot from "./components/about_the_robot/about_the_robot";

function App() {
  return (
    <>
      <Header />
      <SectionHero />
      <ProductSection />
      <AboutTheRobot />
      <CtaAboutUs />
      <Footer />
    </>
  );
}

export default App;
